import styled from 'styled-components'

export const customModalStyles = {
  content: {
    top: 'auto',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    alignItems: 'center',
    display: 'flex',
    height: '182px',
    maxWidth: '760px',
    width: '760px',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    justifyContent: 'left',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: '10',
  },
}

export const CloseModalButton = styled.button`
    background: none!important;
    font-size: 14px;
    border: none;
    cursor: pointer;
    padding: 0;
    color: slategray;
    font-size: 22px;
  `
